export default __webpack_public_path__ + "static/media/sbux.36bdf125.png";